import { render, staticRenderFns } from "./TutorialsTable.vue?vue&type=template&id=1681ed0a&"
import script from "./TutorialsTable.vue?vue&type=script&lang=js&"
export * from "./TutorialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports